/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter, applyFilters } from '@wordpress/hooks';
import { RangeControl, ToggleControl } from '@wordpress/components';

/**
 * Inner dependencies.
 */
import Accordion from '../../../components/Accordion';
import blockInfo from '../constants';
const { hookPrefix, layouts } = blockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-content`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content`,
	( content, props ) => {
		const { attributes, setAttributes, updateInnerBlocks } = props;
		const { layout, columns, hasNavigation, hasPagination, spaceBetween } = attributes;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion tabs={ [
					{
						name: 'slider-options',
						initialOpen: true,
						label: () => {
							return __( 'Slider' );
						},
						cb: () => {
							return <>
								{ layouts && <div className="gutenify-template-browser">
									<h2>Templates</h2>

									<ul>
										{ layouts.map( ( template ) => {
											let classnames = 'gutenify-template-browser-item';
											if ( layout === template.name ) {
												classnames += ' gutenify-template-browser-item-active';
											}
											return <li className={ classnames } key={ template.name }>
												<button className={ `gutenify-template-browser-selector` } onClick={ () => {
													const data = {
														layout: template.name,
														socialIconAlign: template.socialIconAlign,
														imageAlign: template.imageAlign,
														titleAlign: template.titleAlign,
													};
													setAttributes( data );
													updateInnerBlocks( template );
												} }>
													<img src={ `${ window.gutenify_block_data.plugin_directory_url }/assets/images/gallery-carousel-layouts/${ template.name }.png` } alt={ template.name } />
													<small>{ template.label }</small>
												</button></li>;
										} ) }
									</ul>
								</div> }
								<ToggleControl
									label={ __( 'Enable Navigation', 'gutenify' ) }
									checked={ hasNavigation }
									help={
										hasNavigation
											? __( 'Showing slider navigation.', 'gutenify' )
											: __( 'Toggle to enable slider navigation.', 'gutenify' )
									}
									onChange={ () => setAttributes( { hasNavigation: ! hasNavigation } ) }
								/>
								<ToggleControl
									label={ __( 'Enable Pagination', 'gutenify' ) }
									checked={ hasPagination }
									help={
										hasPagination
											? __( 'Showing slider pagination.', 'gutenify' )
											: __( 'Toggle to enable slider pagination.', 'gutenify' )
									}
									onChange={ () => setAttributes( { hasPagination: ! hasPagination } ) }
								/>
								<hr />
								<RangeControl
									label={ __( 'Columns' ) }
									value={ columns }
									onChange={ ( value ) => {
										setAttributes( { columns: value } );
									} }
									min={ 1 }
									max={ applyFilters( `gutenify--${ hookPrefix }--max-columns`, 3 ) }
									step={ 1 } />
								<RangeControl
									label={ __( 'Slider space' ) }
									value={ spaceBetween }
									onChange={ ( value ) => {
										setAttributes( { spaceBetween: value } );
									} }
									min={ 0 }
									max={ 100 }
									step={ 1 }
									help={ __( 'Space between each slide.' ) } />
								{ applyFilters( `gutenify--${ hookPrefix }--inspector--tab-content--slider`, [], props ) }
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);
